import useGroup from '../zustand/useGroup';
import useReportLog, { IAppliedReport } from './useReportLog';

/**
 * The filter, timezone, asset and devices of the loaded logs.
 *
 * The filter of useGroup follows the form while it is edited, so what is
 * calculated from the logs reads the one they were requested with: it only
 * changes when Apply brings new logs. Before any logs it is the one of
 * useGroup.
 */
const useAppliedReportFilter = (): IAppliedReport => {
  const { filter, timezone, asset, devices } = useGroup();
  const { appliedReport } = useReportLog();

  return appliedReport || { filter, timezone, asset, devices };
};

export default useAppliedReportFilter;
